export class RoomTour {
  constructor() {
    this.roomTourTarget = '.c-button--tour';
    this.roomTourCloseBtnTarget = '.virtual-tour-dialog__button';
    this.init();
  }

  static openModal = (url) => {
    document.getElementById('iframeContent').src = url;
    document.getElementById('roomTourModal').style.display = 'block';
    document.getElementById('roomTourOverlay').style.display = 'block';
    document.body.classList.add('overflow-hidden');
  };

  static closeModal = () => {
    document.getElementById('roomTourModal').style.display = 'none';
    document.getElementById('roomTourOverlay').style.display = 'none';
    document.getElementById('iframeContent').src = '';
    document.body.classList.remove('overflow-hidden');
  };

  init = () => {
    const accomodationsDialog = document?.querySelector('#roomTourModal');

    if (accomodationsDialog) {
      document.querySelectorAll(this.roomTourTarget).forEach((item) => {
        item?.addEventListener('click', (e) => {
          e.preventDefault();
          const iframeLink = e.target.href;
          RoomTour.openModal(iframeLink);
        });
      });
    }

    this.hooks();
  };

  hooks = () => {
    document.querySelector(this.roomTourCloseBtnTarget)?.addEventListener('click', RoomTour.closeModal);
    document.querySelector('.virtual-tour-dialog__overlay')?.addEventListener('click', RoomTour.closeModal);

    document.addEventListener('click', (event) => {
      if (event.target === document.getElementById('roomTourModal')) {
        RoomTour.closeModal();
      }
    });
  };
}
